import ApiService from "../api";

export default class ReceitaService extends ApiService {

    constructor() {
        super("/api/receitas");
    }

    atualizaReceitas() {
        return this.put("");
    }

    relatorioReceita(values) {
        const {
            ano = [],
            mes = [],
            logistico = [],
            centroCusto = [],
            contaContabil = [],
            filial = [],
            tipo = [],
        } = values;

        const params = new URLSearchParams();

        if (ano) params.append("ano", ano.join(","));
        if (mes) params.append("mes", mes.join(","));
        if (centroCusto.length) params.append("centroCusto", centroCusto.join(","));
        if (contaContabil.length) params.append("contaContabil", contaContabil.join(","));
        if (logistico.length) params.append("logistico", logistico.join(","));
        if (filial.length) params.append("filial", filial.join(","));
        if (tipo.length) params.append("tipo", tipo.join(","));

        return this.get(`/valor-receita-bruta?${params}`);
    }

    importarExcel({
        file,
        filial,
        data,
        conta,
        historico,
        valor,
        centroCusto,
        doc
    }) {
        const formData = new FormData();

        formData.append("file", file);
        formData.append("filial", filial);
        formData.append("data", data);
        formData.append("conta", conta);
        formData.append("historico", historico);
        formData.append("valor", valor);
        formData.append("centroCusto", centroCusto);
        formData.append("doc", doc);

        return this.post("/importar", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }

}
